import styled from "styled-components";

export const Styles = styled.div`
  label {
    font-family: "Inter";
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    margin-bottom: 9px;

    span {
      color: #777777;
    }

    &.Mui-focused,
    &.MuiInputLabel-shrink {
      top: 0;
    }
  }

  .before-photo,
  .after-photo {
    &.ant-upload-wrapper,
    .ant-upload.ant-upload-select {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }

  .add-photo-wrapper {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-bottom: 38px;
  }

  .add-work-item-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 10px;

    button {
      width: 200px;
    }
  }

  .box-item {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #dce6ef;
    border-radius: 8px;
    padding: 0;
    background-color: #ffffff;
    overflow: hidden;
  }

  .box-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 20px;
    background-color: #f8fbff;
  }

  .box-item-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: "Inter";
    font-weight: 700;
    font-size: 14px;
    color: #000000;
  }

  .box-item-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #347bc3;
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;
    flex-shrink: 0;
  }

  .box-item-body {
    padding: 8px 20px 20px;
  }

  .box-item-collapsed-preview {
    padding: 8px 20px 12px;

    .input-field {
      margin-bottom: 0;
    }
  }

  .box-item-actions {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .toggle-work-item-btn {
    width: 24px;
    height: 24px;
    padding: 0;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      transition: transform 0.2s ease;
    }

    &.is-expanded svg {
      transform: rotate(180deg);
    }
  }

  .delete-work-item-btn {
    width: auto;
    height: auto;
    padding: 0;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      display: block;
      filter: invert(32%) sepia(78%) saturate(2476%) hue-rotate(346deg)
        brightness(96%) contrast(92%);
    }
  }

  .upload-block {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #dce6ef;
    border-radius: 8px;
    padding: 0;
    margin-bottom: 24px;
    background-color: #ffffff;
    overflow: hidden;
  }

  .upload-block-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 20px;
    background-color: #f8fbff;
  }

  .upload-block-title {
    font-family: "Inter";
    font-weight: 700;
    font-size: 14px;
    color: #000000;
  }

  .upload-block-body {
    padding: 16px 12px 8px;
  }

  .add-photo-wrapper,
  .add-work-item-wrapper {
    button {
      width: 184px;
      height: 46px;
      background-color: #347bc3;
      color: #ffffff;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      border-radius: 4px;
      cursor: pointer;

      p {
        font-family: "Inter";
        font-weight: 400;
        font-size: 11px;
        color: #ffffff;
        margin: 0;
      }
    }
  }

  .upload-wrapper {
    display: flex;
    gap: 14px;
    width: 100%;
    margin-bottom: 16px;

    .item {
      width: 100%;
      > div {
        border: 1px dashed #707070;
        width: 480px;
        height: 360px;
        display: flex;
        justify-content: center;
        align-items: center;

        .photo {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }

  .field-wrapper {
    display: flex;
    flex-direction: column;
    gap: 29px;
    position: relative;

    .MuiOutlinedInput-notchedOutline {
      border-color: #bcbcbc;
      border-width: 1px;

      &:hover {
        border-color: #bcbcbc;
      }
    }

    .MuiFormControl-root {
      width: 100%;

      .MuiInputBase-input {
        padding: 19.3px 14px;
        font-family: "Inter";
        font-weight: 400;
        font-size: 16px;
      }
    }

    .input-field {
      width: 100%;
      margin-bottom: 38px;

      &.comment-field {
        .MuiInputBase-input {
          padding: 0;
        }
      }
    }
  }

  input {
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
`;
